(function () {
  const STORAGE_KEY = 'vgp_gta_popup_seen';
  const DELAY_MS = 2500;

  function openPopup() {
    const overlay = document.getElementById('vgp-gta-overlay');
    if (!overlay) return;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    const overlay = document.getElementById('vgp-gta-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    sessionStorage.setItem(STORAGE_KEY, '1');
  }

  function init() {
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    const closeBtn = document.getElementById('vgp-gta-close');
    const confirmBtn = document.getElementById('vgp-gta-confirm');
    const overlay = document.getElementById('vgp-gta-overlay');

    if (!overlay) return;

    closeBtn?.addEventListener('click', closePopup);
    confirmBtn?.addEventListener('click', closePopup);

    // Close on backdrop click
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    setTimeout(openPopup, DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
